import { render, staticRenderFns } from "./HelpPricing.vue?vue&type=template&id=0b505c98&scoped=true"
import script from "./HelpPricing.vue?vue&type=script&lang=js"
export * from "./HelpPricing.vue?vue&type=script&lang=js"
import style0 from "./HelpPricing.vue?vue&type=style&index=0&id=0b505c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b505c98",
  null
  
)

export default component.exports